<template>
  <div class="m-promo" role="region" :aria-label="title">
    <div class="m-promo__row">
      <img v-if="logo" :src="logo" alt="" class="m-promo__logo" />
      <span v-else-if="icon" class="m-promo__icon" aria-hidden="true">
        <i :class="['fas', 'fa-' + icon]"></i>
      </span>
      <div class="m-promo__text">
        <strong>{{ title }}</strong>
        <small v-if="subtitle">{{ subtitle }}</small>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-sm m-promo__cta"
        :disabled="busy"
        @click="$emit('cta')"
      >
        {{ ctaLabel }}
      </button>
      <button
        v-if="dismissLabel"
        type="button"
        class="m-promo__close"
        :aria-label="dismissLabel"
        @click="$emit('dismiss')"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <slot />
  </div>
</template>

<script>
/**
 * Tarjeta de aviso del teléfono (logo o ícono, título, subtítulo y un botón). Con
 * `dismissLabel` muestra la ✕ y emite «dismiss»; sin él queda fija. El slot va debajo.
 * La usan «Instalá la app» y «Activá las notificaciones».
 */
export default {
  name: "MobilePromoCard",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    logo: { type: String, default: "" },
    icon: { type: String, default: "" },
    ctaLabel: { type: String, default: "" },
    busy: { type: Boolean, default: false },
    dismissLabel: { type: String, default: "" },
  },
};
</script>

<style scoped>
.m-promo {
  margin: 0.5rem 0.75rem 0;
  padding: 0.6rem 0.5rem 0.6rem 0.75rem;
  border: 1px solid var(--m-border);
  border-radius: 0.75rem;
  background: var(--m-surface);
  color: var(--m-text);
  box-shadow: var(--bs-box-shadow-sm);
}
.m-promo__row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.m-promo__logo,
.m-promo__icon {
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.6rem;
}
.m-promo__logo {
  object-fit: cover;
}
.m-promo__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--bs-primary-rgb), 0.12);
  color: var(--bs-primary);
  font-size: 1.05rem;
}
.m-promo__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}
.m-promo__text strong {
  font-size: 0.92rem;
}
.m-promo__text small {
  color: var(--m-muted);
  font-size: 0.78rem;
}
.m-promo__cta {
  flex-shrink: 0;
  margin: 0;
  border-radius: 999px;
  text-transform: none;
}
.m-promo__close {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--m-muted);
}
.m-promo__close:active {
  background: var(--m-pressed);
}
</style>
